'use strict'

/**
 *
 * @name: nnBaseVideo
 *
 */

import DirectiveTemplate from './nn-base-video.directive.html'
import './nn-base-video.directive.scss'

function NnBaseVideoDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      video: '=*',
      videoUrl: '=*',
      onVideoPlay: '&',
      posterSrc: '=*',

      showNowPlayingBadge: '=*',
      promotedTheme: '=*', // small / medium

      analyticsLabel: '=*',
      onAnalyticsClick: '&',

      hideActionButtons: '=*',
      hidePlaylistBtn: '=*',
      showRemoveFromQueeBtn: '=*',

      aspectRatio: '=*',
      height: '=*',
    },
    template: DirectiveTemplate,
    controller: nnBaseVideoDirectiveController
  }
}

function nnBaseVideoDirectiveController ($scope) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */



  /*
   *
   * @PUBLIC
   *
   */

  $scope.videoNotPublished = () => {
    //statusCn bysxz
    return !$scope.video.isPublished || $scope.video.statusCn !== 'published'
  }

  $scope.onListBtnClick = () => {
    $scope.video.overlaySettings.hasPlaylistOverlay = true
    $scope.video.overlaySettings.show = 'list'
  }


  /*
   *
   * @PRIVATE
   *
   */



  /*
   *
   * @INIT
   *
   */

}

export default NnBaseVideoDirective



// WEBPACK FOOTER //
// ./app/components/nn-base-components/nn-base-video/nn-base-video.directive.js